const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToParam = require("./util/date-to-param").dateToParam;

const DealRankingActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

DealRankingActions.fetchData.listen(function(period, users, funnel) {
  let params = {
    start_date: dateToParam(period.startDate),
    end_date: dateToParam(period.endDate),
    users: users,
    funnel: funnel
  };

  biAPI.fetch("/deal_ranking", params, this.completed, this.failed);
});

module.exports = DealRankingActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/deal-ranking-actions.js